import { useEffect } from "react";
import { getRum } from "../../aws-app-monitor/rum";

export const LandingPageRumTracker: React.FC = () => {
  /*
    CloudWatch RUM – Landing Page Visitor Tracking
    Tracks visitors to the landing page to analyze user interactions in CloudWatch dashboards.
  */
  useEffect(() => {
    const rum = getRum();
    if (!rum) return;

    // Page view (entry)
    rum.recordEvent("landing_page_visitors", {
      route: "/",
    });

    return () => {
      // Page exit
      rum.recordEvent("landing_page_exit", {
        route: "/",
      });
    };
  }, []);

  return null;
};
